import { daysOfTheWeekP } from '@monorepo/helpers';
import { Dispatch, FC, SetStateAction, useMemo, useState } from 'react';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { Modal } from 'react-bootstrap';
import { publicMinistryServices } from 'src/services';
import { typePublicMinistryMonthlyService, typePublicMinistryService } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetConfig, useGetIsDarkMode, useGetIsMobile, useGetShowingLoadingModal } from 'src/custom-hooks';
import Select from 'react-select';

type propsType = {
    closeModal: () => void;
    monthlyService: typePublicMinistryMonthlyService;
    service: typePublicMinistryService;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
};

export const HTHActivityServiceCrud: FC<propsType> = ({ closeModal, monthlyService, service, setRefreshCounter }) => {
    const [territoryNumber, setTerritoryNumber] = useState(0);
    const config = useGetConfig();
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    const showingLoadingModal = useGetShowingLoadingModal();

    const isValid: boolean = useMemo(() =>
        !!territoryNumber
    , [territoryNumber]);

    const saveHandler = () => {
        if (!isValid) {
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            title: '¿Agregar?',
            message: `Se va a agregar el territorio ${territoryNumber} a la salida`,
            mode: 'confirm',
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await publicMinistryServices.AddTerritoryToHTHService(service.id, territoryNumber, monthlyService.month, monthlyService.year);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                setRefreshCounter(x => x + 1);
                closeModal();
            }
        }));
    }

    return (
        <Modal show size={'lg'} onHide={closeModal}>
            <Modal.Header className={isDarkMode ? 'bg-dark text-white' : ''} closeButton>
                <h5>
                    AGREGAR UN TERRITORIO {isMobile ? '' : 'A LA SALIDA'}
                </h5>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-lightdark text-white' : ''}>
                <h5>
                    {service.typeOfRegularity <= 2 ? `Los ${daysOfTheWeekP[service.weekday!]}` : `El ${daysOfTheWeekP[service.weekday!]} ${service.day}`} a las {service.hour.toString().padStart(2, '0')}:{service.minutes.toString().padStart(2, '0')} hs. - Salida {service.captain1 ? `de ${service.captain1?.name} ${service.captain1?.lastName}` : 'sin capitán'}
                </h5>
                <h6>
                    Territorios de la Asignación: {!!service.territories.length ? `${service.territories.join(', ')}` : 'ninguno'}
                </h6>
                <Select className={'maxw-400 text-dark my-4'}
                    options={
                        Array.from({ length: config.numberOfTerritories }, (_, i) => i + 1)
                            .map(t => ({ territory: t }))
                            .filter(t => !service.territories.includes(t.territory))
                    }
                    getOptionLabel={t => `Territorio ${t?.territory}`}
                    getOptionValue={t => t?.territory.toString() || ''}
                    placeholder={'Agregar Territorio'}
                    value={territoryNumber ? { territory: territoryNumber } : null}
                    onChange={t => {
                        const v = t?.territory;
                        if (!v) {
                            return;
                        }
                        setTerritoryNumber(v);
                    }}
                />
                <p className={'mb-0'}>
                    Este territorio se va agregar a la salida indicada, como último en la lista. Cualquier otro cambio se debe hacer accediendo a la sección de Servicio Público.
                </p>
            </Modal.Body>
            <Modal.Footer className={isDarkMode ? 'bg-dark text-white' : ''}>
                <div className={'d-flex justify-content-center gap-2'}>
                    <button className={'btn btn-general-blue'}
                        style={{ width: '150px' }}
                        onClick={saveHandler}
                        disabled={!isValid || showingLoadingModal}
                    >
                        Guardar
                    </button>
                    <button className={'btn btn-general-red'}
                        style={{ width: '150px' }}
                        onClick={closeModal}
                        disabled={showingLoadingModal}
                    >
                        Cancelar
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
